import { render, staticRenderFns } from "./ReCommentsAll.vue?vue&type=template&id=56ffadec&scoped=true"
import script from "./ReCommentsAll.vue?vue&type=script&lang=js"
export * from "./ReCommentsAll.vue?vue&type=script&lang=js"
import style0 from "./ReCommentsAll.vue?vue&type=style&index=0&id=56ffadec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ffadec",
  null
  
)

export default component.exports